import { Doc } from '@dadohr/shared/domainTypes/document';
import { IOrganization } from '@dadohr/shared/domainTypes/org';
import { Button, Card } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import React from 'react';
import { ButtonWithPromise } from '../../../../../../../components/ButtonWithPromise';
import { useDialogState } from '../../../../../../../hooks/useDialogState';
import { CanvasBar } from '../../../../../../../layout/Canvas';
import { FlexContainer } from '../../../../../../../layout/Flex';
import { Section } from '../../../../../../../layout/Section';
import { callFirebaseFunction } from '../../../../../../../services/firebaseFunctions';
import { isDemoCompany } from '../../../../../../services/orgs';
import { publishTopic } from '../../../../../../services/pubsub';
import { ImportCustomDataFieldsDialog } from './CustomDataFieldsImportDialog';

type Props = {
  org: Doc<IOrganization>;
};

export const Actions: React.FC<Props> = ({ org }) => {
  const { enqueueSnackbar } = useSnackbar();
  const importCustomFieldsDialog = useDialogState(false);
  return (
    <Section>
      <CanvasBar>
        <div>Actions</div>
      </CanvasBar>

      <Card>
        <FlexContainer wrap="wrap">
          {/* The only red (destructive) action on the page. */}
          <ButtonWithPromise
            variant="contained"
            color="secondary"
            pending="Scheduling..."
            onClick={async () => {
              const result = await callFirebaseFunction(
                'schedules-manuallyExcecuteScvhedulesForOrg',
                {
                  orgId: org.id
                }
              );
              console.log(result);
            }}
          >
            Manually trigger schedules for this org
          </ButtonWithPromise>

          <Button
            variant="contained"
            color="primary"
            onClick={() => importCustomFieldsDialog.openDialog()}
          >
            Import Custom Data Fields from other org
          </Button>
          {importCustomFieldsDialog.dialogOpen && (
            <ImportCustomDataFieldsDialog
              targetOrg={org}
              open={true}
              onClose={importCustomFieldsDialog.closeDialog}
            />
          )}

          {isDemoCompany(org.id) && (
            <ButtonWithPromise
              variant="contained"
              color="primary"
              pending="Starting..."
              onClick={() =>
                publishTopic({
                  topic: 'sampleContent-refreshDemoOrg',
                  payload: { orgId: org.id }
                }).then(
                  () => {
                    enqueueSnackbar(
                      'Regenerating in the background. Please wait for 2-3 minutes for the process to finish.'
                    );
                  },
                  () => {
                    enqueueSnackbar('Failed to start regeneration.');
                  }
                )
              }
            >
              Manually regenerate demo content
            </ButtonWithPromise>
          )}
        </FlexContainer>
      </Card>
    </Section>
  );
};
